webpackJsonp([29],{

/***/ 198:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BuzonPage_vue_vue_type_template_id_ec22e31c_scoped_true___ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BuzonPage_vue_vue_type_script_lang_js___ = __webpack_require__(461);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__BuzonPage_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__BuzonPage_vue_vue_type_template_id_ec22e31c_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__BuzonPage_vue_vue_type_template_id_ec22e31c_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "ec22e31c",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BuzonPage_vue_vue_type_script_lang_js___ = __webpack_require__(462);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_BuzonPage_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 462:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BuzonPage',
  data: function data() {
    return {
      cargandoDatos: false,
      dialog: false,
      dialogSave: false,
      dialogRespuesta: false,
      headers: [{
        text: 'Fecha',
        value: 'fecha',
        width: '150px'
      }, {
        text: 'Titulo',
        value: 'titulo'
      }, {
        text: 'Estado',
        value: 'pendiente',
        width: '150px'
      }],
      quejaSugerencia: {
        titulo: '',
        mensaje: ''
      },
      lista: [],
      itemBuzon: {
        respuesta: ''
      }
    };
  },
  methods: {
    getQuejasYSugerencias: function getQuejasYSugerencias() {
      var _this = this;
      this.cargandoDatos = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('alumno/buzon').then(function (response) {
        _this.cargandoDatos = false;
        _this.lista = response.data;
      });
    },
    guardarQuejaYSugerencia: function guardarQuejaYSugerencia() {
      var _this2 = this;
      this.dialogSave = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('alumno/buzon', this.quejaSugerencia).then(function () {
        _this2.dialogSave = false;
        _this2.dialog = false;
        _this2.getQuejasYSugerencias();
      });
    },
    mostrarRespuesta: function mostrarRespuesta(item) {
      this.dialogRespuesta = true;
      this.itemBuzon = item;
    }
  },
  mounted: function mounted() {
    this.getQuejasYSugerencias();
  }
});

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_BuzonPage_vue_vue_type_template_id_ec22e31c_scoped_true___ = __webpack_require__(549);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_BuzonPage_vue_vue_type_template_id_ec22e31c_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_BuzonPage_vue_vue_type_template_id_ec22e31c_scoped_true___["b"]; });


/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"md12":""}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Buzón de Quejas y Sugerencias")])])]),_vm._v(" "),_c('v-card-text',[_c('p',[_c('v-btn',{attrs:{"color":"teal","dark":"","large":"","outline":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._v("\n                            Nueva queja o sugerencia\n                        ")])],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.lista,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.fecha))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.titulo))]),_vm._v(" "),_c('td',[(props.item.pendiente)?_c('v-btn',{attrs:{"flat":"","disabled":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("hourglass_empty")]),_vm._v("\n                                    Pendiente\n                                ")],1):_vm._e(),_vm._v(" "),(!props.item.pendiente)?_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){return _vm.mostrarRespuesta(props.item)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("visibility")]),_vm._v("\n                                    Ver Respuesta\n                                ")],1):_vm._e()],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Nueva queja o sugerencia")])]),_vm._v(" "),_c('v-form',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-text-field',{attrs:{"label":"Título"},model:{value:(_vm.quejaSugerencia.titulo),callback:function ($$v) {_vm.$set(_vm.quejaSugerencia, "titulo", $$v)},expression:"quejaSugerencia.titulo"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-textarea',{attrs:{"label":"Mensaje","counter":"","maxlength":"2048"},model:{value:(_vm.quejaSugerencia.mensaje),callback:function ($$v) {_vm.$set(_vm.quejaSugerencia, "mensaje", $$v)},expression:"quejaSugerencia.mensaje"}})],1),_vm._v(" "),_c('v-divider')],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"blue-grey darken-1"},on:{"click":function($event){_vm.dialog = !_vm.dialog; _vm.quejaSugerencia = {titulo: '', mensaje: ''}}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.dialogSave,"disabled":_vm.dialogSave,"color":"primary","flat":""},on:{"click":_vm.guardarQuejaYSugerencia}},[_vm._v("Guardar")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"280px","persistent":""},model:{value:(_vm.cargandoDatos),callback:function ($$v) {_vm.cargandoDatos=$$v},expression:"cargandoDatos"}},[_c('v-card',[_c('v-card-title',[_c('v-progress-circular',{attrs:{"size":50,"indeterminate":"","color":"primary"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticStyle:{"max-width":"150px"}},[_vm._v("Cargando lista de quejas y/o sugerencias")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialogRespuesta),callback:function ($$v) {_vm.dialogRespuesta=$$v},expression:"dialogRespuesta"}},[_c('v-card',[_c('v-card-text',[_c('span',{staticClass:"grey--text"},[_vm._v("Queja o sugerencia")]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.itemBuzon.mensaje)}}),_vm._v(" "),_c('span',{staticClass:"grey--text"},[_vm._v("Respuesta")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.itemBuzon.respuesta.respuesta))])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.dialogRespuesta = !_vm.dialogRespuesta}}},[_vm._v("Cerrar")])],1)],1)],1)],1)
}
var staticRenderFns = []



/***/ })

});


// WEBPACK FOOTER //
// static/js/29.0f92c2703ca7638b869a.js